import { render, staticRenderFns } from "./PerformanceUser.vue?vue&type=template&id=6cf33e8a&"
import script from "./PerformanceUser.vue?vue&type=script&lang=js&"
export * from "./PerformanceUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports